// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from '@rails/ujs';
// import Turbolinks from 'turbolinks'; // Disable Turbolinks because it breaks the SearchApp Vuejs app
import * as ActiveStorage from '@rails/activestorage';
// import fontawesome from '@fortawesome/fontawesome-free/js/all';
import '@fortawesome/fontawesome-free/css/all';
import '../channels';
import '../controllers';

Rails.start();
// Turbolinks.start(); // Disable Turbolinks because it breaks the SearchApp Vuejs app
ActiveStorage.start();

require('../stylesheets/application.scss');

require.context('../images', true);
